/* "Load more" for page-archive.hbs. The archive is a custom Page template,
   not a native Ghost collection route, so it doesn't get the automatic
   posts/pagination context (or the <link rel=next> + infinite-scroll that
   assets/js/pagination.js relies on for tag/author archives). Instead this
   fetches subsequent pages straight from the public Content API — using the
   key Ghost exposes via the {{content_api_key}} helper for exactly this
   kind of client-side use — and renders cards matching partials/void-card.hbs
   by hand, since there's no shared template to call into from JS. */
(function () {
    const feed = document.querySelector('[data-void-archive-feed]');
    const button = document.querySelector('[data-void-loadmore]');
    if (!feed || !button) return;

    const apiUrl = button.getAttribute('data-site-url').replace(/\/+$/, '') + '/ghost/api/content/';
    const apiKey = button.getAttribute('data-key');
    const filter = button.getAttribute('data-filter');
    let nextPage = button.getAttribute('data-next-page');

    function escapeHtml(value) {
        const div = document.createElement('div');
        div.textContent = value == null ? '' : String(value);
        return div.innerHTML;
    }

    /* Mirrors Ghost's img_url helper: inserts /size/w{width}/ after /content/images/ */
    function imageUrl(raw, width) {
        if (!raw) return '';
        return raw.replace('/content/images/', '/content/images/size/w' + width + '/');
    }

    function formatDate(iso) {
        return new Date(iso).toLocaleDateString('en-US', {month: 'short', day: '2-digit', year: 'numeric'});
    }

    function cardHtml(post) {
        const author = post.authors && post.authors[0];
        const tag = post.primary_tag;
        const excerpt = post.custom_excerpt || post.excerpt || '';
        const title = escapeHtml(post.title);
        const url = escapeHtml(post.url);

        let html = '<div class="void-card void-card-column">';

        html += '<div class="void-card-image"><a href="' + url + '">';
        html += '<div class="void-image void-aspect-3-2">';
        html += '<img src="' + escapeHtml(imageUrl(post.feature_image, 600)) + '" alt="' + escapeHtml(post.feature_image_alt || post.title) + '" loading="lazy">';
        html += '</div></a></div>';

        html += '<div class="void-card-content">';
        if (tag) {
            html += '<div class="void-tags"><a href="' + escapeHtml(tag.url) + '" class="void-tag"' +
                (tag.accent_color ? ' style="color:' + escapeHtml(tag.accent_color) + '"' : '') +
                '>' + escapeHtml(tag.name) + '</a></div>';
        }
        html += '<h3 class="void-heading"><a href="' + url + '">' + title + '</a></h3>';
        if (excerpt) {
            html += '<p class="void-card-excerpt">' + escapeHtml(excerpt) + '</p>';
        }
        html += '<div class="void-byline">';
        if (author) {
            html += '<a class="void-byline-author" href="' + escapeHtml(author.url) + '">';
            if (author.profile_image) {
                html += '<img class="void-byline-author-img" src="' + escapeHtml(imageUrl(author.profile_image, 160)) + '" alt="' + escapeHtml(author.name) + '">';
            }
            html += '<span class="void-byline-author-name">' + escapeHtml(author.name) + '</span></a>';
        }
        html += '<time class="void-byline-date" datetime="' + escapeHtml(post.published_at) + '">' + formatDate(post.published_at) + '</time>';
        html += '</div></div></div>';

        return html;
    }

    button.addEventListener('click', function () {
        if (!nextPage) return;

        button.disabled = true;

        let url = apiUrl + 'posts/?key=' + encodeURIComponent(apiKey) + '&limit=10&page=' + encodeURIComponent(nextPage) + '&include=tags,authors';
        if (filter) {
            url += '&filter=' + encodeURIComponent(filter);
        }

        fetch(url)
            .then(function (res) { return res.json(); })
            .then(function (data) {
                const wrapper = document.createElement('div');
                wrapper.innerHTML = (data.posts || []).map(cardHtml).join('');
                while (wrapper.firstChild) {
                    feed.appendChild(wrapper.firstChild);
                }

                const pagination = data.meta && data.meta.pagination;
                nextPage = pagination && pagination.next;

                if (nextPage) {
                    button.disabled = false;
                } else {
                    button.parentElement.remove();
                }
            })
            .catch(function () {
                button.disabled = false;
            });
    });
})();
